<!--
	Collapsible panel of intervention recommendations for the selected feature.
	Shown only for Identify (Curve) or Prioritize (Corridor) layer types.
-->
<script lang="ts">
	import { featureSelectionStore } from '#lib/stores/featureSelectionStore.svelte.js';
	import { EIdentify, EPrioritize } from '../interfaces';
	import type { SafeCurvesLayerId } from '../interfaces';
	import CollapsiblePanel from '#lib/components/CollapsiblePanel.svelte';
	import Curve from './Curve.svelte';
	import Corridor from './Corridor.svelte';
	import { playbookLink } from '../header';

	import IconArrowTopRightOnSquare from '#lib/assets/arrow-top-right-on-square.svg?raw';

	const feature = $derived(featureSelectionStore.current);
	const systemId = $derived(featureSelectionStore.currentSystemId as SafeCurvesLayerId | undefined);

	const showPanel = $derived(
		!!feature && (systemId === EIdentify.Identify || systemId === EPrioritize.Prioritize)
	);
</script>

{#if showPanel && feature && systemId}
	<CollapsiblePanel title="Countermeasures" grow transparent>
		<p class="playbookRef">
			Refer to the <a href={playbookLink} target="_blank">
				SafeCurves Playbook (PDF)<span aria-hidden="true">{@html IconArrowTopRightOnSquare}</span
				><span class="screenReaderOnly"> (opens in new tab)</span>
			</a>
			for further information regarding countermeasures and flow charts deriving the countermeasures shown
			below.
		</p>
		{#if systemId === EIdentify.Identify}
			<Curve {feature} />
		{:else}
			<Corridor {feature} />
		{/if}
	</CollapsiblePanel>
{/if}

<style>
	.playbookRef {
		font-size: var(--font-size-sm);

		a {
			display: inline-flex;
			align-items: center;
			gap: var(--space-1);
		}
	}
</style>
